import { TransferStoreWorkshopDetailPrintModel } from "./transfer-store-workshop-detail-print.model";

export class TransferStoreWorkshopPrintModel {
    transferStoreWorkshopId: number = 0;
    enterpriseLogo: string | null = null;
    enterpriseName: string = '';
    consecutive: number = 0;
    alterNumber: number | null = null;
    branchName: string = '';
    branchAddress: string = '';
    branchPhone: string = '';
    observation: string = '';
    dateTransferStoreWorkshop: Date = new Date();
    typeTransferStoreWorkshop: string = '';
    stateTransferStoreWorkshop: string = '';
    userAuthenticated: string = '';
    transferStoreWorkshopDetails: TransferStoreWorkshopDetailPrintModel[] = [];
}
